import { Center, Loader } from '@mantine/core';

const LazyLoaderSpinner = () => {
  return (
    <Center style={{ minHeight: '50px' }}>
      <Loader type="oval" />
    </Center>
  );
};

export default LazyLoaderSpinner;
